import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle } from "lucide-react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-8">
          <div className="max-w-md w-full text-center space-y-4">
            <AlertTriangle size={48} className="mx-auto text-amber-500" />
            <h1 className="text-xl font-semibold text-slate-800">
              Algo salió mal / Something went wrong
            </h1>
            <p className="text-slate-600 text-sm">
              Por favor recargue la página. / Please reload the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="btn-primary"
            >
              Recargar / Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
